/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ShopLeftNavComponent_viewer$ref = any;
export type ShopLeftNavComponent_viewer = {
    readonly user: ({
        readonly id: string;
        readonly email: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly role: string | null;
        readonly accountRole: ({
            readonly accountRoleTitle: string | null;
        }) | null;
        readonly permissions: ({
            readonly id: string;
            readonly oneCommerce: ({
                readonly id: string;
                readonly ceo: ({
                    readonly access: boolean | null;
                }) | null;
            }) | null;
        }) | null;
    }) | null;
    readonly " $refType": ShopLeftNavComponent_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ShopLeftNavComponent_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "role",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "accountRole",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccountRoleType",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "accountRoleTitle",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "permissions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PermissionsType",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "oneCommerce",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OneCommerceType",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "ceo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "AccessType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "access",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '9725821bf19b3b18ff61c5abc71859bb';
export default node;
